import React from "react";
import "./Error.css";

export default function Error(props) {
  //recieve props from Dictionary
  // console.log(props.error);

  if (props.error === "input value is empty") {
    //if result is not empty, we show response, to see how looks response< just check /console.log(props.results);
    return (
      <section className="Error">
        <h3>{props.error}</h3>
      </section>
    );
  } else {
    return (
      <section className="Error">
        <h3>{props.error.title}</h3>
        <p>{props.error.message}</p>
        <p>
          <em>{props.error.resolution}</em>
        </p>
      </section>
    );
  }
}
